import { makeStyles, Tooltip } from '@material-ui/core';
import { haptic } from 'utils/haptics';

/** The small pill toggle used across the person card (experience scope,
 *  recent-matters period, competencies view). */
const useStyles = makeStyles({
  toggle: {
    display: 'flex',
    gap: 4,
  },
  button: {
    fontSize: 11,
    fontWeight: 500,
    padding: '3px 8px',
    borderRadius: 6,
    cursor: 'pointer',
    border: 'none',
    transition: 'background-color 0.15s, color 0.15s, transform 0.1s',
    userSelect: 'none' as const,
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none' as const, // no iOS long-press menu
    '&:active': {
      transform: 'scale(0.93)',
    },
  },
  active: {
    backgroundColor: '#38566B',
    color: 'white',
  },
  inactive: {
    backgroundColor: '#f0f0f0',
    color: '#888',
    '@media (hover: hover)': {
      '&:hover': {
        backgroundColor: '#e4e4e4',
      },
    },
  },
});

function SegmentedToggle<T extends string>({
  options,
  value,
  onChange,
}: {
  options: { value: T; label: string; tooltip?: string }[];
  value: T;
  onChange: (value: T) => void;
}) {
  const classes = useStyles();

  return (
    <div className={classes.toggle}>
      {options.map((option) => (
        <Tooltip key={option.value} title={option.tooltip ?? ''} arrow placement="top">
          <button
            className={`${classes.button} ${value === option.value ? classes.active : classes.inactive}`}
            onClick={() => {
              if (option.value === value) return;
              haptic('light');
              onChange(option.value);
            }}
          >
            {option.label}
          </button>
        </Tooltip>
      ))}
    </div>
  );
}

export default SegmentedToggle;
